<!-- Order Confirmation Section -->
<div class="container-fluid p-0" *ngIf="orderStatus === 'success'">
  <!-- Order Confirmation Banner -->
  <div class="bg-success text-white py-5 text-center">
    <div class="container">
      <div class="fs-2 fw-bold mb-3">Order Confirmed!</div>
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
      </svg>
      <div class="fs-5 mt-4">Thank you for your purchase with <strong>SmartDukaan</strong>!</div>
      <div class="fs-5 mt-2">Your Order ID is: <a class="fw-bold text-white" [routerLink]="'/user/profile/orders/'+pendingOrder.id">#{{ pendingOrder.id }}</a></div>
    </div>
  </div>

  <!-- Order Details Section -->
  <div class="container my-5">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card shadow-sm">
          <div class="card-header bg-light">
            <h5 class="card-title fw-bold mb-0">Order Summary</h5>
          </div>
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-6">
                <strong>Order ID:</strong> {{ pendingOrder.id }}
              </div>
              <div class="col-md-6">
                <strong>Order Date:</strong> {{ pendingOrder.createTimestamp | date: 'mediumDate' }}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <strong>Payment Method:</strong> {{ pendingOrder.payMethod }}
              </div>
              <div class="col-md-6">
                <strong>Total Amount:</strong> {{ pendingOrder.totalAmount | currency:"INR" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Product Details Section -->
  <div class="container my-5">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card shadow-sm">
          <div class="card-header bg-light">
            <h5 class="card-title fw-bold mb-0">Product Details</h5>
          </div>
          <div class="card-body">
            <div class="row align-items-center mb-3" *ngFor="let item of pendingOrder.pendingOrderItems">
              <div class="col-md-3 col-12 d-flex justify-content-center">
                <img [src]="item.imgUrl" alt="Product Image" class="img-fluid rounded" style="max-width: 100px;">
              </div>
              <div class="col-md-6 col-12">
                <strong>{{ item.itemName }}</strong><br>
                <span class="text-muted">Quantity: {{ item.quantity }}</span>
              </div>
              <div class="col-md-3 col-12 text-md-end text-center">
                <strong>{{ item.sellingPrice | currency:"INR" }}</strong>
              </div>
              <div *ngIf="item.pendingOrderItemPolicyPlan.length" class="row align-items-center mb-3  text-secondary">
                <div class="col-md-3 col-12 d-flex ">
                </div>
                <div class="col-md-6 col-12 d-flex justify-content-center fs-7 fw-semibold ">
                  <span> <i class="pi pi-check-circle"></i>{{  item.pendingOrderItemPolicyPlan[0]?.planName }}</span>
                </div>
                <div class="col-md-3 col-12 text-md-end text-center fs-6 text-black ">
                  <strong class="mb-0">
                    {{ item.pendingOrderItemPolicyPlan[0]?.premiumPrice | currency:"INR" }}
                  </strong>
                </div>
              </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Store Address Section -->
  <div class="container my-5" *ngIf="storeAddress.name">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card shadow-sm">
          <div class="card-header bg-light">
            <h5 class="card-title fw-bold mb-0">Store Details</h5>
          </div>
          <div class="card-body">
            <div class="fs-6">
              <strong>{{ storeAddress.name }}</strong><br>
              {{ storeAddress.line1 }} {{ storeAddress.line2 }}<br>
              {{ storeAddress.city }} - {{ storeAddress.pinCode }}, {{ storeAddress.state }}<br>
              <strong>Contact Number:</strong> {{ storeAddress.phoneNumber }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Customer Support Section -->
  <div class="bg-light py-4 text-center align-items-center">
    <div class="container mb-5">
      <div class="fs-5">For any queries or concerns, call our Customer Care at <strong>1800 270 0273</strong>.</div>
    </div>
  </div>
</div>

<!-- Payment Failed Section -->
<div class="container-fluid p-0" *ngIf="orderStatus === 'failed'">
  <div class="bg-danger text-white py-5 text-center">
    <div class="container">
      <img src="../src/assets/images/order-failed.png" alt="Payment Failed" class="img-fluid mb-4" style="max-width: 200px;">
      <div class="fs-2 fw-bold mb-3">Payment Failed</div>
      <div class="fs-5">Please try again or choose Pay on Delivery.</div>
      <div class="mt-4">
        <a role="button" [routerLink]="'/cart'" class="btn btn-light text-black">Retry Payment</a>
        <a role="button" [routerLink]="'/cart'" class="btn btn-light text-black ms-3">Pay on Delivery</a>
      </div>
    </div>
  </div>
</div>
